export default {
  ACCESS_TEACHER: 'ACCESS_TEACHER',
  ACCESS_MANAGER: 'ACCESS_MANAGER',
  ACCESS_EDITOR: 'ACCESS_EDITOR',
};
